import { useTranslation } from "react-i18next";
import type { DealerDeviceTransferNotification } from "@/gql/graphql";
import DataListItemText from "@/components/app/Navigation/GlobalHeader/Notifications/Data/DataListItemText";

type DeviceTransferRequestApprovedNotificationProps = {
  data: Pick<DealerDeviceTransferNotification, "model" | "serialNumber">;
};

const DeviceTransferRequestApprovedNotification = (
  props: DeviceTransferRequestApprovedNotificationProps
) => {
  const { data } = props;
  const { model, serialNumber } = data;
  const { t } = useTranslation();

  return (
    <DataListItemText
      primary={t("notifications.device_transfer_request_approved.title")}
      secondary={t(
        "notifications.device_transfer_request_approved.description",
        { model: model ?? "", serialNumber }
      )}
    />
  );
};

export default DeviceTransferRequestApprovedNotification;
